module.exports = new __parcel__URL__("leaderboard_mining_button.412a6725.png").toString();